class FabricCanvasMemoryReference {
  /** @type {import('fabric').Canvas | null} */
  static canvas = null;

  /**
   * @type {{
   *   text_primary: string | null,
   *   text_secondary: string | null,
   *   base_primary: string | null,
   *   base_secondary: string | null
   * }}
   */

  static designColors = {
    text_primary: null,
    text_secondary: null,
    base_primary: null,
    base_secondary: null,
  };

  static initialDesignColors = {
    text_primary: null,
    text_secondary: null,
    base_primary: null,
    base_secondary: null,
  };

  static resetDesignColors = () => {
    this.designColors = this.initialDesignColors;
  };

  /**
   * @param {import('fabric').Canvas} canvas
   */

  static setCanvas(canvas) {
    this.canvas = canvas;
  }

  /** @returns {import('fabric').Canvas | null} */

  static getCanvas() {
    return this.canvas;
  }

  static getDesignColors() {
    return this.designColors;
  }

  static deleteSelected() {
    if (!this.canvas) return;

    const objects = this.canvas.getActiveObjects();

    this.canvas.remove(...objects);
    this.canvas.discardActiveObject();
    this.canvas.requestRenderAll();
  }

  /**
   * Normalizes a hex color string.
   * @param {string} color - The hex color string.
   * @returns {string|null} Normalized hex color in lowercase.
   */
  static normalizeHexColor(color) {
    if (!color) return null;

    if (typeof color !== "string") {
      return color;
    }

    return color?.trim()?.toLowerCase();
  }

  /**
   * Replaces a color with its corresponding agency color if it matches the template colors.
   * @returns {string} The replaced color or the original color if no match is found.
   */
  static replaceWithAgencyColors = ({ color, obj }) => {
    const normalizedColor = this.normalizeHexColor(color);
    const objId = obj?.id ?? "";

    /**
     * Sample ids with colors data
     * using-base-colors_color-base-primary_align-left_text-limit-22_width-480
     * color-text-primary_align-left_text-limit-22_width-480
     */

    let baseColorPrimary = false;
    let baseColorSecondary = false;
    let textColorPrimary = false;
    let textColorSecondary = false;

    if (objId.includes("color-text-primary")) {
      textColorPrimary = true;
    }

    if (objId.includes("color-text-secondary")) {
      textColorSecondary = true;
    }

    if (objId.includes("color-base-primary")) {
      baseColorPrimary = true;
    }

    if (objId.includes("color-base-secondary")) {
      baseColorSecondary = true;
    }

    if (baseColorPrimary) {
      return this.designColors.base_primary;
    }

    if (baseColorSecondary) {
      return this.designColors.base_secondary;
    }

    if (textColorPrimary) {
      return this.designColors.text_primary;
    }

    if (textColorSecondary) {
      return this.designColors.text_secondary;
    }
  };

  static updateColorsForCanvasObjects = () => {
    const fabricCanvasInstance = this.canvas;

    if (fabricCanvasInstance) {
      const allObjects = fabricCanvasInstance.getObjects();

      // console.log("Updating color: ");

      for (let _idx = 0; _idx < allObjects.length; _idx++) {
        const obj = allObjects[_idx];
        // console.log("layer id: ", obj.id);
        let disableColorUpdates = false;

        // console.log("Layer name: ", obj?.id);

        if (obj?.id?.includes("lock-color")) {
          disableColorUpdates = true;
        }

        if (!disableColorUpdates) {
          if (obj?.fill) {
            obj.set(
              "fill",
              this.replaceWithAgencyColors({ color: obj.fill, obj }),
            );
          }
          if (obj?.stroke) {
            obj.set(
              "stroke",
              this.replaceWithAgencyColors({ color: obj.stroke, obj }),
            );
          }
          if (obj?.textBackgroundColor) {
            obj.set(
              "textBackgroundColor",
              this.replaceWithAgencyColors({
                color: obj.textBackgroundColor,
                obj,
              }),
            );
          }
          if (obj?.backgroundColor) {
            obj.set(
              "backgroundColor",
              this.replaceWithAgencyColors({ color: obj.backgroundColor, obj }),
            );
          }
        }
      }

      this.canvas.requestRenderAll();
    }
  };

  static setAndUpdateDesignColors(colorUpdates) {
    this.designColors = colorUpdates;

    this.updateColorsForCanvasObjects();
  }
}

export default FabricCanvasMemoryReference;
